import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { Music2 } from "lucide-react";
import api, { formatApiErrorDetail } from "../lib/api";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated. Please sign in.");
      navigate("/login", { replace: true });
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-ivory grid place-items-center p-4">
      <div className="w-full max-w-md card-base p-6 sm:p-8" data-testid="reset-card">
        <Link to="/" className="inline-flex items-center gap-2 mb-6">
          <span className="w-9 h-9 rounded-xl bg-sage-500 text-white grid place-items-center"><Music2 size={20} /></span>
          <span className="font-heading font-semibold text-lg">AMDS</span>
        </Link>
        <h1 className="font-heading text-2xl font-bold tracking-tight">Choose a new password</h1>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <input type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} className="input-field" placeholder="New password" data-testid="reset-password-input" />
          <button type="submit" disabled={busy || !token} className="btn-primary w-full justify-center" data-testid="reset-submit-btn">{busy ? "Saving…" : "Update password"}</button>
        </form>
        {!token && <div className="mt-4 text-sm text-terracotta-600">Reset link is missing or invalid.</div>}
      </div>
    </div>
  );
}
